// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".x-text-field[data-v-20674b04]{display:flex}.x-text-field[data-v-20674b04] .help-button{margin-top:2px}[data-v-20674b04] .x-input.v-text-field.v-text-field--enclosed>.v-input__control>.v-text-field__details{margin-bottom:-3px}", ""]);
// Exports
module.exports = exports;
